import type { MachineDetail } from "@/features/lines/hooks";

export interface BasicForm {
  code: string;
  name: string;
  type: "MACHINE" | "EQUIPMENT" | "HUMAN";
  requiresOperator: boolean;
  stoppedCostPerHour: string;
  /** Spec 078 — id do modelo 3D ou "" (bloco genérico) */
  model3dId: string;
}

export function toForm(m: MachineDetail | undefined): BasicForm {
  return {
    code: m?.code ?? "",
    name: m?.name ?? "",
    type: (m?.type as BasicForm["type"]) ?? "MACHINE",
    requiresOperator: m?.requiresOperator ?? false,
    stoppedCostPerHour:
      m?.stoppedCostPerHour !== null && m?.stoppedCostPerHour !== undefined
        ? String(m.stoppedCostPerHour)
        : "",
    model3dId: m?.model3dId ?? "",
  };
}
